import { TReliabilityType } from '../../../types/developerV2/reliability';

export type TTheme = 'green' | 'red';

export const statusToTheme = (status: TReliabilityType): TTheme => {
  const themes = {
    problem: 'red',
    reliable: 'green',
  };

  return themes[status] as TTheme;
};
